<div
  class="fixed top-6 right-6 z-[9999] w-[360px] rounded-2xl border border-[#FCA5A5] bg-[#FEF2F2] shadow-xl p-4 flex items-center gap-3 animate-slide-in"
>
  <div
    class="w-10 h-10 rounded-full bg-[#FEE2E2] flex items-center justify-center"
  >
    <img src="/icons/error-form.svg" alt="error" />
  </div>

  <div class="flex-1">
    <h4 class="font-semibold text-[#991B1B]">
      {{ "Flight_Details.Missing_Fields" | translate }}
    </h4>

    <p class="text-sm text-[#B91C1C] mt-1">
      {{ "Flight_Details.Fill_Fields_Msg" | translate }}
    </p>
  </div>
</div>
